// Chaque type d'integration n'expose qu'une partie des champs.
// Cette table pilote a la fois le formulaire, la construction du payload et l'affichage de la carte.
export const INTEGRATION_TYPES = {
    CASHDRO: {protocol: true, username: true, password: true},
    CCV_OPI: {ip: true, localPrint: true},
    NEPT_OPI: {ip: true, localPrint: true},
    CASH_BOX: {protocol: true, username: true, webtoolUrl: true, authKey: true},
    CTEP: {serialNumber: true},
    NEPTINGA2A: {serialNumber: true},
    LOYALTEK: {protocol: true, serialNumber: true},
    CASHMATIC: {protocol: true, username: true, password: true}
};

// Types dont l'adresse est stockee sous la cle "url" et non "ip".
const URL_TYPES = ['LOYALTEK'];

export function integrationFields(type) {
    return INTEGRATION_TYPES[type] || {};
}

export function usesUrlKey(type) {
    return URL_TYPES.includes(type);
}

export function cleanIp(ip) {
    return ip?.replace(/^https?:\/\//, '') ?? '';
}

export function parseConfig(configJson) {
    if (!configJson) return {};
    try {
        return JSON.parse(configJson);
    } catch (e) {
        return {};
    }
}

export function integrationLabel(integration) {
    const config = parseConfig(integration.configJson);
    const detail = cleanIp(config.ip || config.url) || config.serialNumber;
    return [integration.type, detail].filter(Boolean).join(' · ');
}

// Seul un prefixe https:// explicite vaut https : une adresse sans schema est traitee en http.
export function protocolOf(address) {
    return address?.startsWith('https://') ? 'https' : 'http';
}
